import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export default function TermsOfUseRoute() {
	return (
		<main>
			<div className="container flex flex-col items-center justify-between gap-10 py-20">
				<h1 className="underline decoration-accent-purple decoration-wavy underline-offset-4">
					Terms of Use
				</h1>
				<div className="relative overflow-clip">
					<div
						aria-hidden
						className="absolute -right-10 -top-10 h-56 w-56 rounded-full bg-[#4042E2] opacity-40 blur-[76px] dark:opacity-20"
					></div>
					<div
						aria-hidden
						className="absolute -bottom-10 -left-10 h-56 w-56 rounded-full bg-[#4042E2] opacity-40 blur-[76px] dark:opacity-20"
					></div>
					<div className="max-w-3xl space-y-5 rounded-lg bg-muted py-4 pl-12 pr-8">
						<ol className="list-decimal">
							<li>
								By accessing this website (the “Site”), you acknowledge these
								terms and conditions of use and agree to be bound by them. If
								you do not agree to these terms, please discontinue accessing
								the Site immediately.
							</li>
							<li>
								We reserve the right, in our sole discretion, to modify, alter
								or otherwise update these terms and conditions at any time and
								you agree to be bound by such modifications, alterations or
								updates.
							</li>
							<li>The content of the Site is published by Arpit Dalal.</li>
							<li>
								This Site is only intended to provide insights and cannot be
								solely relied upon for making any decisions.
							</li>
							<li>
								You will be solely responsible for maintaining the security of
								your account and password.
							</li>
							<li>
								You agree not to engage in any activity that may disrupt or
								interfere with the functioning of the Site.
							</li>
							<li>
								You will not use the Site for any unlawful purpose or in
								violation of any applicable laws or regulations.
							</li>
							<li>
								Your use of the Site is subject to our{' '}
								<Link to="/privacy" className="underline">
									Privacy Policy
								</Link>
								. By using the Site, you consent to the collection and use of
								information as outlined in the{' '}
								<Link to="/privacy" className="underline">
									Privacy Policy
								</Link>
								.
							</li>
							<li>
								The Site and its original content, features, and functionality
								are owned by Arpit Dalal and are protected by intellectual
								property laws.
							</li>
							<li>
								We will not be liable for any indirect, incidental, special,
								consequential, or punitive damages, or any loss of profits or
								revenues arising out of or related to your use of the Site.
							</li>
							<li>
								We reserve the right to terminate or suspend your access to the
								Site at any time without prior notice for violating these Terms
								or for any other reason.
							</li>
							<li>
								We reserve the right to refuse service to anyone for any reason
								at any time.
							</li>
							<li>
								Shall you have any questions or concerns about these Terms,
								please contact{' '}
								<Link to="mailto:arpitdalalm@gmail.com" className="underline">
									support
								</Link>
								.
							</li>
						</ol>
					</div>
				</div>
			</div>
		</main>
	)
}

export const meta: MetaFunction = () => [{ title: 'Terms of Use | X̂ Man' }]
